/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_Language_DetectedInputs */

const en_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`detected`)
};

const de_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erkannt`)
};

const fr_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectee`)
};

const es_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detectado`)
};

const it_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevata`)
};

const nl_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gedetecteerd`)
};

const pl_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykryty`)
};

const fi_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunnistettu`)
};

const da_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registreret`)
};

const sv_output_language_detected = /** @type {(inputs: Output_Language_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detekterat`)
};

/**
* | output |
* | --- |
* | "detected" |
*
* @param {Output_Language_DetectedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const output_language_detected = /** @type {((inputs?: Output_Language_DetectedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_Language_DetectedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_output_language_detected(inputs)
	if (locale === "fr") return fr_output_language_detected(inputs)
	if (locale === "es") return es_output_language_detected(inputs)
	if (locale === "it") return it_output_language_detected(inputs)
	if (locale === "nl") return nl_output_language_detected(inputs)
	if (locale === "pl") return pl_output_language_detected(inputs)
	if (locale === "fi") return fi_output_language_detected(inputs)
	if (locale === "da") return da_output_language_detected(inputs)
	if (locale === "sv") return sv_output_language_detected(inputs)
	return en_output_language_detected(inputs)
});